import styled from 'styled-components';
import { fontStyle, flexPosition } from '../../../../styles/mixins';
import {
  GRAY_MEDIUM,
  FONT_SIZE_7,
  GRAY_DARKER,
  FONT_SIZE_5,
  FONT_WEIGHT_BOLD,
  GRAY_LIGHTER,
  FONT_SIZE_6,
  INFO_COLOR,
} from '../../../../styles/variables';

export const VariationContainer = styled.div``;

export const Header = styled.div`
  width: 100%;
  padding: 0px 10px 10px;
  border-bottom: 1px solid ${GRAY_LIGHTER};
`;

export const Title = styled.h2`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  width: 100%;
  margin-top: 0px;
  ${fontStyle(GRAY_DARKER, FONT_SIZE_5, FONT_WEIGHT_BOLD)}
`;

export const Subtitle = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  width: 100%;
`;

export const Text = styled.div`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_7)}
`;

export const OptionsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 10px;
`;

export const Option = styled.li`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  width: 100%;
  margin-bottom: 15px;
`;

export const OptionName = styled.p`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin: 0;
`;

export const OptionPrice = styled.p`
  ${fontStyle(INFO_COLOR, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/ProductAddons/CustomSteps/VariationAddonItem/style.js